<template>
  <div class="app-container flex-1 page row-center">
    <div class="content flex flex-col">
      <img :src="require('@/assets/images/404.png')" alt="" />
      <p class="m-t-8">
        当前页面不存在
        <router-link :to="{ name: 'Homepage' }" replace>返回工作台</router-link>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style scoped lang="scss">
.page {
  background-color: $info-fifth-color;

  .content {
    img {
      width: pixel-to-rem($n: 437);
    }

    p {
      color: #5e8bdb;
      @include text-bold;
      font-size: pixel-to-rem($n: 20);
      text-align: center;
    }
  }
}
</style>
